import { observer } from 'mobx-react-lite'
import { type FC, useMemo } from 'react'
import classnames from 'classnames'
import { SectionColumn } from 'pages/conversations/pages/search/pages/profile/ui/SectionColumn/SectionColumn'
import { type SectionMessagesStore } from 'pages/conversations/pages/search/pages/profile/ui/SectionMessages'
import { ProviderSectionMessages } from 'pages/conversations/pages/search/pages/profile/ui/SectionMessages/context/sectionMessagesContext'
import { MessagesList } from 'pages/conversations/pages/search/pages/profile/ui/SectionMessages/ui/MessagesList/MessagesList'
import { useProfilePageContext } from 'pages/conversations/pages/search/pages/profile/context/profileContext'
import { HeaderNewConversation } from 'pages/conversations/pages/search/pages/profile/ui/SectionMessages/ui/HeaderNewConversation/HeaderNewConversation'
import { HeaderDefault } from './HeaderDefault/HeaderDefault'
import styles from './styles.module.scss'

const SectionMessagesContent = observer(() => {
  const profilePageStore = useProfilePageContext()
  const { sectionConversationStore } = profilePageStore
  const { isNewConversation } = sectionConversationStore

  const renderHeader = useMemo(() => {
    if (isNewConversation) {
      return <HeaderNewConversation />
    }

    return <HeaderDefault />
  }, [isNewConversation])

  return (
    <>
      <SectionColumn
        className={classnames(styles.wrap, {
          [styles.isNew]: isNewConversation,
        })}
        classNameContent={styles.content}
        classNameHeader={classnames(styles.header, {
          [styles.isNew]: isNewConversation,
        })}
        renderHeader={renderHeader}
        isEmpty={!sectionConversationStore.conversation}
      >
        <MessagesList />
      </SectionColumn>
    </>
  )
})

type ISectionMessagesProps = {
  store: SectionMessagesStore
}

export const SectionMessages: FC<ISectionMessagesProps> = observer(({ store }) => {
  return (
    <ProviderSectionMessages value={store}>
      <SectionMessagesContent />
    </ProviderSectionMessages>
  )
})
